import { XMarkIcon } from "@heroicons/react/24/solid";
import { integerName } from "../../../app/utils";
import { AlertLevel } from "../../../components/AlertMessage";
import ButtonWithConfirm from "../../../components/ButtonWithConfirm";
import {
	CourseUserViewModel,
	useRemoveProctorFromCoursesMutation,
	useRemoveWriterFromCoursesMutation,
} from "../../courses/coursesApiSlice";

interface RemoveFromCourseProps {
	isRemovingTeacher: boolean;
	selectedUsers: CourseUserViewModel[];
	courseId: number;
	isLoading: boolean;
	resetTable: () => void;
	setIsLoading: (loading: boolean) => void;
}

export default function RemoveUsersFromCourseButton(props: RemoveFromCourseProps) {
	const length = props.selectedUsers.length;

	const [removeWriterFromCourses] = useRemoveWriterFromCoursesMutation();
	const [removeProctorFromCourses] = useRemoveProctorFromCoursesMutation();

	async function handleRemove() {
		props.setIsLoading(true);

		const promises = props.selectedUsers.map(async (user) => {
			props.isRemovingTeacher
				? removeProctorFromCourses({
						courseIds: [props.courseId],
						userId: user.userId,
					})
				: removeWriterFromCourses({
						courseIds: [props.courseId],
						writerId: user.userId,
					})
						.unwrap()
						.catch((error) => {
							console.error(`Error removing ${user.name} from course:`, error);
						});
		});

		await Promise.all(promises);
		props.resetTable();
	}

	return (
		<ButtonWithConfirm
			id={`remove-${props.isRemovingTeacher ? "teacher" : "student"}-from-course-button`}
			className="btn btn-neutral"
			disabled={length == 0 || props.isLoading}
			message={`Are you sure you want to remove ${integerName(length)} selected ${props.isRemovingTeacher ? "teacher" : "student"}${length == 1 ? "" : "s"} from the course?`}
			type={AlertLevel.Warning}
			confirmLabel="Yes"
			cancelLabel="No"
			onConfirm={handleRemove}>
			<XMarkIcon className="h-4 inline mr-2" />
			Remove
		</ButtonWithConfirm>
	);
}
